import moment from 'moment';
import { BaseEntity, MemoizeGetters, toDate, Transform } from './base';

export type EventType = 'inspection.completed' | 'appointment.created' | 'appointment.updated' | 'appointment.canceled';

/** Webhook integration provisioned by Yoshi ops and managed by the partner. */
@MemoizeGetters
export class Integration extends BaseEntity {
  name: string;
  webhookUrl: string;
  enabled: boolean;
  eventTypes: EventType[];
  authType: 'hmac_sha256';
  deliveryType: 'webhook';

  /** Masked hint, e.g. "whsec_…abcd". Present everywhere except rotate_secret. */
  signingSecretHint: string;

  /** Full secret value — only returned by rotate_secret, shown once. */
  signingSecret?: string;

  @Transform(toDate)
  previousSecretActiveUntil?: Date | null;

  @Transform(toDate)
  createdAt: Date;

  @Transform(toDate)
  updatedAt: Date;

  get statusLabel(): string {
    return this.enabled ? 'Enabled' : 'Disabled';
  }

  get hasPreviousSecretActive(): boolean {
    return !!this.previousSecretActiveUntil && moment(this.previousSecretActiveUntil).isAfter(moment());
  }

  get previousSecretActiveUntilFormatted(): string {
    return this.previousSecretActiveUntil ? moment(this.previousSecretActiveUntil).format('LLL') : '';
  }
}

export interface UpdateIntegrationParams {
  webhookUrl?: string;
  enabled?: boolean;
  eventTypes?: EventType[];
}

export interface RotateSecretParams {
  graceHours?: number;
  force?: boolean;
}

export interface TestResult {
  status: number;
  body: string;
}
